import { getButtonFilters } from './getFilters/getButtonFilters';
import { getDropdownFilters } from './getFilters/getDropdownFilters';
import { getQueryOptions } from './getFilters/getQueryOptions';
import { getQueryParams } from './getFilters/getQueryParams';
import { getSearchField } from './getFilters/getSearchField';
import { getWsFormFilters } from './getFilters/getWsFormFilters';

/**
 * This function puts together an array of URL params string of currently active filters.
 *
 * @author rafhun <rafhun@cubetech.ch>
 * @export
 * @param {HTMLElement} parent
 * @returns {Array} Each item is the query string for one filter
 */
export function getCurrentFilters(parent) {
    // Get the API infos
    const api = JSON.parse(parent.dataset.ctRest);

    // initialize array that will hold all filter information
    const apiFilters = [];

    // check current URL for possible prefill data
    if (!parent.dataset.ctRestInitialized) {
        const queryParams = getQueryParams();
        if (queryParams) {
            apiFilters.push(queryParams);
        }

        // mark the app as initialized so URL is ignored on further filter refreshs
        parent.dataset.ctRestInitialized = 'true';
    }

    const queryOptions = getQueryOptions(api);
    if (queryOptions) {
        apiFilters.push(queryOptions);
    }

    // Handle a search input
    const searchString = getSearchField(parent);
    if (searchString) {
        apiFilters.push(searchString);
    }

    // Handle dropdown filters
    const dropdownFilters = getDropdownFilters(parent);
    if (dropdownFilters) {
        apiFilters.push(dropdownFilters);
    }

    const buttonFilters = getButtonFilters(parent);
    if (buttonFilters) {
        apiFilters.push(buttonFilters);
    }

    const wsFormFilters = getWsFormFilters(parent);
    if (wsFormFilters) {
        apiFilters.push(wsFormFilters);
    }

    // remove all empty entries in the array
    return apiFilters.filter((item) => item !== '');
}
